import {
  GET_SURVEY_FILTER_OPTIONS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/surveys/filter_options/get'
import type { SurveyFilterOptions, SurveyFilterOptionsParams } from 'app/common/types/surveys'
import type { CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import { useSurveyData } from './useSurveyData'

const defaultState: SurveyFilterOptions = {
  cities: [],
  districts: [],
  schools: [],
  schoolTypes: [],
}

type Options = CommonDataOptions<SurveyFilterOptions, SurveyFilterOptionsParams>

export const useSurveyFilterOptions = (options: Options) => {
  const res = useSurveyData({
    ...options,
    requestValue: GET_SURVEY_FILTER_OPTIONS,
    error: 'Не удалось получить данные для фильтров опросов',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
